/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/defense_local_open': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M16 22c-4.687 0-8.5-3.813-8.5-8.5S11.313 5 16 5s8.5 3.813 8.5 8.5S20.687 22 16 22zm0-16c-4.136 0-7.5 3.364-7.5 7.5S11.864 21 16 21s7.5-3.364 7.5-7.5S20.136 6 16 6z"/><circle pid="1" cx="16" cy="13.5" r="2"/><path pid="2" d="M15.5 13.5h1v13h-1zM4.5 32H0v-4.5h1V31h3.5zM32 32h-4.5v-1H31v-3.5h1zM32 4.5h-1V1h-3.5V0H32zM1 4.5H0V0h4.5v1H1z"/>'
  }
})
